export function comma(value, digits) {
  return value.toFixed(digits).replace(".", ",");
}

// Precio con el tercer decimal separado, como en los postes de las gasolineras.
export function priceParts(value) {
  const text = comma(value, 3);
  return [text.slice(0, -1), text.slice(-1)];
}

export function formatPrice(value) {
  return `${comma(value, 3)} €/L`;
}

export function formatEuro(value) {
  return `${comma(value, 2)} €`;
}

export function formatSignedEuro(value) {
  if (Math.abs(value) < 0.005) return "0,00 €";
  return `${value > 0 ? "+" : "−"}${comma(Math.abs(value), 2)} €`;
}

export function formatKm(value) {
  if (value < 1) return `${Math.round(value * 1000)} m`;
  return `${comma(value, 1)} km`;
}

export function formatLitres(value) {
  return `${comma(value, 1)} L`;
}

// "18/10/2026 21:38:33" → "21:38" si es de hoy; si no, "18/10 21:38".
export function formatUpdatedAt(value, now = new Date()) {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})/.exec(String(value || ""));
  if (!match) return "";
  const [, day, month, year, hour, minute] = match;
  const today = Number(day) === now.getDate() && Number(month) === now.getMonth() + 1 && Number(year) === now.getFullYear();
  return today ? `${hour}:${minute}` : `${day}/${month} ${hour}:${minute}`;
}

const SMALL_WORDS = new Set(["de", "del", "la", "las", "el", "los", "y", "en", "a"]);

// Pasa a formato de título solo las palabras escritas enteras en mayúsculas.
// Conserva siglas cortas (CC, SN) y códigos con cifras (A-42, N-401).
export function titleCase(value) {
  return String(value || "").trim().split(/(\s+)/).map((word, index) => {
    const letters = word.replace(/[^\p{L}]/gu, "");
    if (!letters || word !== word.toLocaleUpperCase("es") || /\d/.test(word)) return word;
    const lower = word.toLocaleLowerCase("es");
    if (index > 0 && SMALL_WORDS.has(lower)) return lower;
    if (letters.length <= 2) return word;
    return lower.charAt(0).toLocaleUpperCase("es") + lower.slice(1);
  }).join("");
}

// Une las partes de una dirección quitando las repetidas aunque cambien las mayúsculas.
export function tidyAddress(value) {
  const seen = new Set();
  return String(value || "").split(/\s*,\s*/).filter((part) => {
    const key = part.toLocaleLowerCase("es");
    if (!part || seen.has(key)) return false;
    seen.add(key);
    return true;
  }).map(titleCase).join(", ");
}
